
export const generateYears = (startYear) => {

    const currentYear = new Date().getFullYear();
    startYear = startYear || 1980;
    let years = [];
    while (startYear <= currentYear) {
        years.push(startYear++);
    }

    return years.reverse()

}

export const generateMonths = () => {
    let month = 1;
    let months = [];
    while (month <= 12) {
        months.push(month++)
    }

    return months;
}

export const convertDay = (day) => {

    switch (day) {
        case 0:
            return "Minggu"
            break;
        case 1:
            return "Senin"
            break;
        case 2:
            return "Selasa"
            break;
        case 3:
            return "Rabu"
            break;
        case 4:
            return "Kamis"
            break;
        case 5:
            return "Jumat"
            break;
        case 6:
            return "Sabtu"
            break;
    }
}

export const convertMonth = (Month) => {

    switch (Month) {
        case 0:
            return "Januari"
            break;
        case 1:
            return "Februari"
            break;
        case 2:
            return "Maret"
            break;
        case 3:
            return "April"
            break;
        case 4:
            return "Mei"
            break;
        case 5:
            return "Juni"
            break;
        case 6:
            return "Juli"
            break;
        case 7:
            return "Agustus"
            break;
        case 8:
            return "September"
            break;
        case 9:
            return "Oktober"
            break;
        case 10:
            return "November"
            break;
        case 11:
            return "Desember"
            break;
    }
}